import {
  SHStack,
  SHTable,
  SHTableBody,
  SHTableContainer,
  SHTableHead,
  SHTableRow,
  SHTypography,
} from "@components/design-systems";
import { StarSVG } from "@components/svgs";
import { AnalysisFeatureIncludeDTO } from "@models/platform-analysis/entities/steps/feature";
import { flatMap, some } from "lodash";
import { memo } from "react";
import { SummaryFeatureIncludedCell } from "../cell";
import { SummaryFeatureIncludedContent } from "../cell-content";

export interface SummaryFeaturesIncludeTableProps {
  selectedFeatures: AnalysisFeatureIncludeDTO[];
}
export const SummaryFeaturesIncludeTable = memo(
  ({ selectedFeatures }: SummaryFeaturesIncludeTableProps) => {
    const hasEssentialFeature = some(flatMap(selectedFeatures, "features"), {
      isEssential: true,
    });

    return (
      <SHStack alignItems={"flex-end"} spacing={"15px"}>
        <SHTableContainer>
          <SHTable>
            <SHTableHead>
              <SHTableRow>
                <SummaryFeatureIncludedCell isHeader width={"13%"}>
                  Feature group
                </SummaryFeatureIncludedCell>
                <SummaryFeatureIncludedCell isHeader width={"17%"}>
                  Feature sub-group
                </SummaryFeatureIncludedCell>
                <SummaryFeatureIncludedCell isHeader width={"70%"}>
                  Features
                </SummaryFeatureIncludedCell>
              </SHTableRow>
            </SHTableHead>
            <SHTableBody>
              {selectedFeatures?.length ? (
                selectedFeatures?.map((row, index) => (
                  <SHTableRow key={index} sx={{ borderBottomWidth: 1 }}>
                    <SummaryFeatureIncludedCell width={"13%"}>
                      <SHTypography variant="body1">
                        {row.sectionName}
                      </SHTypography>
                    </SummaryFeatureIncludedCell>
                    <SummaryFeatureIncludedCell width={"17%"}>
                      <SHTypography variant="body1">
                        {row.subSectionName}
                      </SHTypography>
                    </SummaryFeatureIncludedCell>
                    <SummaryFeatureIncludedCell width={"80%"}>
                      <SHStack direction={"row"} flexWrap={"wrap"}>
                        {row?.features?.map((feature, index) => (
                          <SummaryFeatureIncludedContent
                            isLasted={index === row?.features.length - 1}
                            key={feature.featureId}
                            feature={feature}
                          />
                        ))}
                      </SHStack>
                    </SummaryFeatureIncludedCell>
                  </SHTableRow>
                ))
              ) : (
                <SHTableRow>
                  <SummaryFeatureIncludedCell colSpan={3}>
                    <SHTypography
                      variant="body1"
                      textAlign={"center"}
                      colorVariant="third"
                    >
                      Don't have features included
                    </SHTypography>
                  </SummaryFeatureIncludedCell>
                </SHTableRow>
              )}
            </SHTableBody>
          </SHTable>
        </SHTableContainer>
        {hasEssentialFeature && (
          <SHStack>
            <SHStack spacing={"5px"} alignItems={"center"} direction={"row"}>
              <StarSVG width={"13px"} height={"13px"} />
              <SHTypography
                variant="body1"
                colorVariant="third"
                paddingTop={"4px"}
              >
                Essential features
              </SHTypography>
            </SHStack>
          </SHStack>
        )}
      </SHStack>
    );
  },
);
